import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { BlueHeader } from '@/components/layout/blue-header'
import { toSafeRedirect } from '@/lib/safe-redirect'
import { useAuthStore } from '@/stores/auth.store'

export const Route = createFileRoute('/_auth')({
  /**
   * Renvoie ailleurs un visiteur DÉJÀ connecté qui ouvre une page de connexion.
   *
   * En `beforeLoad` et non en `useEffect` : l'effet se redéclenchait au moment
   * précis où la connexion réussit, et son `navigate({ to: '/' })` écrasait la
   * destination que le formulaire venait de choisir — le client atterrissait
   * sur l'accueil au lieu de son dossier. `beforeLoad` ne juge qu'à l'entrée
   * sur la page ; une fois dessus, c'est le formulaire qui décide.
   */
  beforeLoad: ({ location }) => {
    const { isAuthenticated, user } = useAuthStore.getState()

    if (isAuthenticated && user) {
      const { redirect: target } = location.search as { redirect?: string }
      throw redirect({ to: toSafeRedirect(target) })
    }
  },
  component: AuthLayout,
})

function AuthLayout() {
  return (
    <div className="flex min-h-screen min-w-screen flex-1 flex-col gap-5 bg-[url('/images/default-background.jpg')] bg-cover bg-center bg-no-repeat">
      <div>
        <BlueHeader />
      </div>
      <div className="flex w-full flex-1 items-center justify-center bg-cover bg-center bg-no-repeat px-4 py-6">
        <div className="z-10 flex w-full max-w-109.5 flex-col items-center justify-center gap-6 rounded-xl bg-white p-5 sm:rounded-2xl sm:p-8">
          <img alt="logo" className="h-14 sm:h-16" src="logos/massilia-logo.png" />
          <Outlet />
        </div>
      </div>
    </div>
  )
}
